import { selectBasket } from 'containers/OrderDetails/basketSlice'
import { selectIsLoggedIn } from '../Login/loginSlice'
import useTranslation from 'hooks/useTranslation'
import Receipt from '../forms/Billing/Receipt'
import Skeleton from 'react-loading-skeleton'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { userInfo } from 'rest/urls'
import { GET } from 'rest/request'

const UserSection = () => {
  const { invoice } = useSelector(selectBasket)
  const isLogin = useSelector(selectIsLoggedIn)
  const [data, setData] = useState({})
  const { t } = useTranslation('basket')

  const getUserData = async (signal) => {
    try {
      const response = await GET(userInfo, { signal })
      if (response.data) setData(response.data)

    } catch (err) {
      console.warn('Fetch: failed')
    }
  }

  useEffect(() => {
    if (isLogin) {
      const controller = new AbortController()
      getUserData(controller.signal)
      return () => {
        controller.abort()
      }
    }
  }, [isLogin])

  if (invoice) {
    return (
      <div>
        <div className='list__header element__title'>{t('invoiceDetails')}</div>
        <div className='list__element --big'>
          <div className='element__title'>
            <div>{invoice?.name}</div>
            <div>NIP: {invoice?.nip}</div>
          </div>

          <div className='element__desc'>
            <div>{invoice?.streetName}</div>
            <div>{invoice?.postalCode} {invoice?.voivodshipName}</div>
            {data?.name
              ? <div>{t('representative')}: {data.name}</div>
              : <Skeleton />}
          </div>
        </div>
      </div>
    )
  }

  return (
    <Receipt independent data={data} />
  )
}

export default UserSection